import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JobInsight } from '../entities/jobs.model';
import { LerApiService } from './ler-api.service';

export interface JobsFilters {
  region?: string;
  industry?: string;
}

@Injectable({ providedIn: 'root' })
export class JobsApiService extends LerApiService {
  private readonly gatedEndpoint = '/v1/ler/job_insights';
  private readonly publicEndpoint = '/v1/ler/credentials';

  loadJobs(filters?: JobsFilters): Observable<JobInsight[]> {
    const params = new URLSearchParams();
    if (filters?.region) {
      params.set('country', filters.region);
    }
    if (filters?.industry) {
      params.set('industry', filters.industry);
    }
    const query = params.toString();
    const url = query ? `${this.gatedEndpoint}?${query}` : this.gatedEndpoint;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'job_insights')),
      catchError((res) => this._handleError(res)),
    );
  }

  loadJobById(id: number, filters?: JobsFilters): Observable<JobInsight> {
    // TODO(Giacomo): Uncomment when the API endpoint is ready
    // return this._get(`${this.endpoint}/${id}`).pipe(
    //   map((res) => this._handleResponse(res, 'job_insight')),
    //   catchError((res) => this._handleError(res)),
    // );
    return this.loadJobs(filters).pipe(map((jobs) => jobs.find((job) => job.id === id)));
  }

  loadJobsByCredentialUuid(credentialUuid: string): Observable<JobInsight[]> {
    const url = `${this.publicEndpoint}/${encodeURIComponent(credentialUuid)}/job_titles`;
    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'job_insights')),
      catchError((res) => this._handleError(res)),
    );
  }
}
